import { z } from 'zod';
import { defineEndpoint } from '../define';
import { CommitShaSchema, VersionStringSchema } from '../release-products/shapes';
import {
  ReleaseDetailSchema,
  SelectedWorkflowsSchema,
  WorkflowInputOverridesSchema,
} from './shapes';

/** Drafts only — immutable after Confirm — except `description`, editable in every status. */
export const UpdateReleaseDraftBodySchema = z
  .object({
    version: VersionStringSchema,
    description: z.string().trim().max(255),
    ref: z.string().trim().max(200),
    commitSha: z.union([CommitShaSchema, z.literal('')]),
    selectedWorkflows: SelectedWorkflowsSchema,
    workflowInputOverrides: WorkflowInputOverridesSchema,
    /** Persisted diff-baseline; null clears it. */
    baseReleaseId: z.string().uuid().nullable(),
    /** Non-empty = auto Publish to testers when the release succeeds (UCH-513). */
    autoDistributeGroups: z.array(z.string().trim().min(1).max(200)).max(50),
  })
  .partial();
export type UpdateReleaseDraftBody = z.infer<typeof UpdateReleaseDraftBodySchema>;

export const updateReleaseDraft = defineEndpoint({
  method: 'PATCH',
  path: '/v1/releases/:releaseId',
  params: z.object({ releaseId: z.string().uuid() }),
  query: z.object({}),
  body: UpdateReleaseDraftBodySchema,
  response: z.object({ data: ReleaseDetailSchema }),
});
